// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"124":"private","543":"locale-en","931":"locale-de"}[chunkId] || chunkId) + "." + {"124":"66d765e2","543":"f375218b","839":"c1c13133","931":"5b886ddd"}[chunkId] + ".chunk.js";
};